 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0504a67c":"789c43da","chunk-0675a897":"3baf4d6f","chunk-076143c7":"63fda274","chunk-13c844ea":"83a4aeeb","chunk-1869a978":"f8178e96","chunk-187610a4":"d29eb649","chunk-18fe7f7b":"9af5d68a","chunk-25b60776":"69bb6028","chunk-2d0ae5c1":"c83596a4","chunk-2d0c4265":"8eef4a06","chunk-2d216257":"fe368abe","chunk-1fac07e7":"6d94e97f","chunk-2844bf84":"04e2ca97","chunk-368cd8ea":"de1e6322","chunk-3a9565d2":"0793372a","chunk-7abc896b":"20b442cc","chunk-9f82b514":"c8eba118","chunk-f9682dd6":"dee496bb","chunk-2d228fd9":"c67500dd","chunk-3a514ecc":"0647f0b9","chunk-3b785ed4":"b536c12a","chunk-3c1d4a60":"8c208239","chunk-3cdcfd7c":"8440c088","chunk-4661a9a8":"0fe09ed3","chunk-56ac56c6":"e5e567e5","chunk-75c99522":"e608f178","chunk-13e878da":"36d619aa","chunk-7050a5c6":"a1557386","chunk-76c48ce8":"2d8df4b7","chunk-7a1104e3":"85c0b006","chunk-b9e6fdf4":"0ef3ea59","chunk-29bba50d":"d24655f9","chunk-73e9b22e":"ff2d9195","chunk-cb06858c":"319a78f6","chunk-cfdf18ac":"fa8763e8","chunk-d1c6da3a":"32961304","chunk-e8cf157c":"b3d501e5","chunk-ee681160":"93c9effa","chunk-159fe3b7":"b153da69","chunk-48778986":"e543ce77","chunk-ef677422":"287b8b96","chunk-f115309e":"618699fb","chunk-f72e5852":"bb793af9","chunk-2d216214":"d895bf80","chunk-635d0d70":"f68e2dea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0504a67c":1,"chunk-0675a897":1,"chunk-076143c7":1,"chunk-13c844ea":1,"chunk-1869a978":1,"chunk-187610a4":1,"chunk-18fe7f7b":1,"chunk-25b60776":1,"chunk-1fac07e7":1,"chunk-2844bf84":1,"chunk-368cd8ea":1,"chunk-3a9565d2":1,"chunk-7abc896b":1,"chunk-9f82b514":1,"chunk-f9682dd6":1,"chunk-3a514ecc":1,"chunk-3b785ed4":1,"chunk-3cdcfd7c":1,"chunk-4661a9a8":1,"chunk-56ac56c6":1,"chunk-75c99522":1,"chunk-13e878da":1,"chunk-7050a5c6":1,"chunk-76c48ce8":1,"chunk-7a1104e3":1,"chunk-b9e6fdf4":1,"chunk-29bba50d":1,"chunk-73e9b22e":1,"chunk-cb06858c":1,"chunk-cfdf18ac":1,"chunk-d1c6da3a":1,"chunk-e8cf157c":1,"chunk-ee681160":1,"chunk-159fe3b7":1,"chunk-48778986":1,"chunk-ef677422":1,"chunk-f115309e":1,"chunk-f72e5852":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0504a67c":"a713b764","chunk-0675a897":"074f34bc","chunk-076143c7":"1aa7ffaa","chunk-13c844ea":"f2e561b4","chunk-1869a978":"64f096e2","chunk-187610a4":"700893ba","chunk-18fe7f7b":"4e9962aa","chunk-25b60776":"8c1199c7","chunk-2d0ae5c1":"31d6cfe0","chunk-2d0c4265":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-1fac07e7":"e505b896","chunk-2844bf84":"a12a03b2","chunk-368cd8ea":"f4d76e19","chunk-3a9565d2":"4792cf41","chunk-7abc896b":"9cedf073","chunk-9f82b514":"41ee11e4","chunk-f9682dd6":"4d3ff75e","chunk-2d228fd9":"31d6cfe0","chunk-3a514ecc":"fa559a16","chunk-3b785ed4":"53240a07","chunk-3c1d4a60":"31d6cfe0","chunk-3cdcfd7c":"3d7d0c42","chunk-4661a9a8":"d0e61336","chunk-56ac56c6":"5c60149b","chunk-75c99522":"470d3666","chunk-13e878da":"e123045d","chunk-7050a5c6":"ab4c3fd7","chunk-76c48ce8":"e44ac6ec","chunk-7a1104e3":"68b4007e","chunk-b9e6fdf4":"3d807993","chunk-29bba50d":"b198f38c","chunk-73e9b22e":"878953f1","chunk-cb06858c":"384730ee","chunk-cfdf18ac":"247f604d","chunk-d1c6da3a":"dcdb0549","chunk-e8cf157c":"d67aca52","chunk-ee681160":"3854600f","chunk-159fe3b7":"d79ca495","chunk-48778986":"b1f33d22","chunk-ef677422":"a2f2668f","chunk-f115309e":"b455d86d","chunk-f72e5852":"fffd1365","chunk-2d216214":"31d6cfe0","chunk-635d0d70":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static-cdn2.ivydad.com/act2/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
